import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['radio', 'comment']

  connect() {
    this.updateCommentRequired()
  }

  updateCommentRequired() {
    if (!this.hasCommentTarget) return

    const selected = this.radioTargets.find(radio => radio.checked)
    this.commentTarget.required = selected && selected.value === 'comment'
  }
}
